import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StrictMode } from 'react';
import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';

import { queryClient } from '@/api/tanstackQueryInstance';
import { ThemeProvider } from '@/context/theme';
import router from '@/routes/routes';

export default function App() {
  return (
    <StrictMode>
      <ThemeProvider defaultTheme="system" storageKey="theme">
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} position={'top'} buttonPosition={'top-right'} />
          <Toaster expand={false} position={'bottom-right'} offset={'1.5rem'} mobileOffset={'1.25rem'} closeButton={true} />
          <RouterProvider router={router} />
        </QueryClientProvider>
      </ThemeProvider>
    </StrictMode>
  );
}
